<template>
    <b-alert v-if="taxpayerInfo" variant="info" show class="text-center">
        <h5>{{ taxpayerInfo.name }}</h5>
        <hr>
        <p>
            {{ `${$t('general.iinbin')}: ${taxpayerInfo.iin || ''}` }}
            <br>
            {{ `${$t('kkm.factoryNum')}: ${Object.keys(report).length ? reportInfo.kkm_factory_num || '' : ''}` }}
            <br>
            {{ `${$t('kkm.registration')}: ${Object.keys(report).length ? reportInfo.kkm_registration_num || '' : ''}` }}
        </p>
        <p>
            {{ $t(`report.types.${report.type}`) }}
            <br>
            {{ report.create_date }}
        </p>
    </b-alert>
</template>

<script>
export default {
    name: 'CashierReportHeading',
    props: {
        taxpayerInfo: Object,
        reportInfo: Object,
        report: Object
    }
}
</script>
